<template lang="html">
  <div class="">

    <Row :gutter="16" v-if="invoices && invoices.filters">

      <Col style="min-width: 140px" :md="1">
        Periodo:<br>
        <Select v-model="filters.period" style="max-width: 100px">
          <!-- <Option :value="''">Tutti</Option> -->
          <template v-for="(year, i) in invoices.filters.years">
            <Option :key="year" :value="year*1"><b>Intero {{ year }}</b></Option>
            <Option v-for="month in invoices.filters.months.filter(m => m.substring(0, 4) == year)" :key="month" :value="month">{{ $d(new Date(month), 'month') }}</Option>
          </template>
        </Select>
      </Col>

      <Col style="min-width: 200px" :md="1">
        Tipo
        <Select v-model="filters.is_a" style="max-width: 140px">
          <Option value="inv;nacc">Fatture & Note di credito</Option>
          <Option value="ric">Ricevute</Option>
          <Option value="nacc">Note di credito</Option>
        </Select>
      </Col>
      <Col style="min-width: 200px" :md="1">
        Emessa/ricevuta:
        <Select v-model="filters.type" style="max-width: 140px">
          <Option value="rec">Ricevute</Option>
          <Option value="sent">Emesse</Option>
        </Select>
      </Col>

      <Col style="min-width: 200px" :md="5">
        Fornitore/cliente:
        <Select v-model="filters.contact_id" style="min-width: 340px" :filterable="true" :clearable="true">
          <Option v-for="c in contacts" :value="c.id" :key="c.id">{{ c.name }}</Option>
        </Select>
      </Col>

      <Col style="min-width: 200px" :md="5">
        Ancora da pagare (sospese) in data:
        <div style="position: relative">
          <LocalDate v-model="filters.suspended_at"/>
        </div>
      </Col>
      <Col style="float: right; text-align:right" :md="5">
        <Button type="primary" @click.native="print_loading2 = true; $utils.download(`fatture.pdf`, 'invoices', Object.assign({_print:1}, params), () => {print_loading2 = false})" :loading="print_loading2">
            <Icon type="printer"></Icon>
            Stampa
        </Button>
      </Col>
    </Row>

    <div style="text-align: right">
      <Button @click.native="$root.$emit('invoice.show', {is_a:'inv'})" type="info">
        <Icon type="plus"></Icon>
        Fattura
      </Button>
      <Button @click.native="$root.$emit('invoice.show', {is_a:'nacc'})" type="error">
        <Icon type="plus"></Icon>
        Nota di credito
      </Button>
      <Button @click.native="$root.$emit('invoice.show', {is_a:'ric'})" type="purple">
        <Icon type="plus"></Icon>
        Ricevuta
      </Button>
    </div>

    <div class="ivu-table spaced" style="margin: 1em 0">
      <table>
        <thead>
          <tr>
            <th style="width: 150px; cursor: pointer" @click="orderBy('protocol')">
              Protocollo
              <Icon v-if="order && order.by=='protocol'" :type="'ios-arrow-'+(order.asc?'down':'up')"/>
            </th>
            <th style="width: 150px">Tipologia</th>
            <th style="width: 100px; cursor: pointer" @click="orderBy('date')">
              Data
              <Icon v-if="order && order.by=='date'" :type="'ios-arrow-'+(order.asc?'down':'up')"/>
            </th>
            <th style="">Numero</th>
            <th>{{(filters.type == 'sent' ? 'Cliente' : 'Fornitore')}}</th>
            <th class="text-right">Totale</th>
            <th class="text-center" v-if="filters.suspended_at">Da pagare al {{ $d(Date.maintain(filters.suspended_at)) }}</th>
            <th class="text-center" v-else>Stato pagamenti</th>
            <th style="width: 120px"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!invoices.data.length">
            <td colspan=3>
              Nessuna fattura trovata
            </td>
          </tr>
          <tr v-for="t in invoices.data" :key="t.id">
            <td>{{ t.protocol }}</td>
            <td v-if="t.is_a == 'inv'">Fattura</td>
            <td v-else-if="t.is_a == 'nacc'">Nota di credito</td>
            <td v-else-if="t.is_a == 'ric'">
              <a v-if="t.is_a='ric'" @click="$utils.print('print-ric/'+t.id)">
                <Icon type="ios-printer"/>&nbsp; Ricevuta
              </a>
            </td>
            <td v-else><code>{{ t.is_a }}</code></td>
            <td>
              {{ $d(Date.maintain(t.date)) }}
            </td>
            <td> {{t.number }} </td>
            <td>
              {{ t.contact_name }}
            </td>
            <td :class="'text-right ' + (t.total && (t.is_a != 'nacc') ? 'text-info' : 'text-error')">{{ $n(t.total, 'currency') }}</td>
            <td class="text-center" v-if="filters.suspended_at">
              {{ $n(t.total - t.paid_on_date, 'currency') }} rimanente
            </td>
            <td class="text-center" v-else>
              <span v-if="t.is_paid">
                Pagata
                <span v-if="t.total < t.total_paid" class="text-error">
                  ({{ $n(t.total_paid, 'currency') }})
                </span>
              </span>
              <span v-else>
                {{ $n(t.total - t.total_paid, 'currency') }} rimanente
              </span>
            </td>
            <td>
                <Button
                @click="$root.$emit('invoice.show', t)"
                type="primary">
                  <Icon type="edit"/>
                </Button>
                &nbsp;
                <Button
                @click="delInvoice(t)"
                type="error">
                  <Icon type="ios-trash"/>
                </Button>
            </td>
          </tr>
        </tbody>
      </table>
      <Spin size="large" fix v-if="loading"/>
    </div>

    <div class="text-center">
      <Page
      style="margin: 1em 0"
      :current="invoices.current_page"
      :total="invoices.total"
      :page-size="invoices.per_page"
      @on-change="refreshInvoices"/>
    </div>

  </div>
</template>

<script>
export default {
  data() {
    var month = new Date()
    month.setDate(1)
    month = month.serializeLocal()
    return {
      loading: true,
      print_loading2: false,
      invoices: {
        data: []
      },
      current_month: month,
      filters: {
        is_a: 'inv;nacc',
        company_id: this.$store.company.id,
        type: 'rec',
        period: (new Date).getFullYear(),
      },
      contacts: [],
      order: {
        by: 'date',
        asc: false,
      },
      page: null,
    }
  },

  computed: {
    params() {
      let params = Object.assign({}, this.filters)
      params.order = this._.clone(this.order)
      if (params.order) {
        params.order.asc*= 1
      }

      if (('' + params.period).length == 4) {
        params.year = params.period
      } else {
        params.month = params.period
      }
      return params
    }
  },

  mounted() {
    this.refreshInvoices()
    this.$root.$on('invoices', this.refreshInvoices)
    this.refreshContacts()
    this.$root.$on('contacts', this.refreshContacts)
  },
  beforeDestroy() {
    this.$root.$off('invoices', this.refreshInvoices)
    this.$root.$off('contacts', this.refreshContacts)
  },

  methods: {
    refreshInvoices(page) {
      if (page !== undefined) {
        this.page = page
      }
      var params = Object.assign({
        page: this.page || 1,
      }, this.params)

      this.loading = true
      this.$http.get('invoices', {params}).then(res => {
        let txs = res.data
        if (!txs.filters.months.includes(this.current_month)) {
          txs.filters.months.push(this.current_month)
          txs.filters.months = txs.filters.months.sort().reverse()
        }
        this.invoices = txs
      }).finally(res => {
        this.loading = false
      })
    },

    refreshContacts(page) {
      var params = {
        company_id: this.$store.company.id,
        is_a: 'inv',
      }
      this.$http.get('contact-names', {params}).then(res => {
        this.contacts = res.data
      })
    },

    delInvoice (inv) {
      if (!confirm(`Sicuri di voler cancellare la fattura ${inv.number}?`)) return

      this.$http.delete(`invoices/${inv.id}`).then(res => {
        let i = this.invoices.data.indexOf(inv)
        i >= 0 && this.invoices.data.splice(i, 1)
      })
    },
    orderBy(by) {
      var asc = false
      if (this.order && this.order.by == by) {
        asc = !this.order.asc
      }
      this.order = { by, asc }

      this.refreshInvoices()
    },
  },

  watch: {
    filters: {
      deep: true,
      handler: require('lodash').debounce(function() {
        this.page = null
        this.refreshInvoices()
      }, 300)
    }
  }
}
</script>

<style lang="css">
</style>
